"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const ko = __importStar(require("knockout"));
const mapping = __importStar(require("knockout-mapping/knockout.mapping"));
require("../knockout-bindings");
var json = $("#page-data").text();
var data = mapping.fromJSON(json);
$(function () {
    ko.applyBindings(data);
});
$("#ticket-form").submit(function (e) {
    e.preventDefault();
    $(".btn").attr("disabled", 'true');
    var post = ko.toJS(data);
    var action = $(this).attr('action');
    var result = $.ajax({
        url: action,
        type: 'POST',
        data: post
    });
    result.done(r => {
        window.location.href = '/tickets';
    });
    result.fail(() => {
        $(".btn").removeAttr("disabled");
    });
});
